export enum UserAssignmentType {
  LEARNING_ROUTE = "LEARNING_ROUTE",
  COURSES = "COURSES",
}
